{
  "title": "評審出現在利益衝突重疊警示清單",
  "description": "審查進度頁的利益衝突清單出現異常組合時的排查與處理方式。",
  "headings": ["症狀", "最常見原因", "排查方式", "正常結果", "仍無法解決"],
  "symptom": "在「審查進度」頁下方的利益衝突清單中，看到某位評審與某件作品同時出現，代表該評審已申報迴避，卻仍持有該作品的進行中指派。",
  "causes": [
    "指派是在該評審申報利益衝突之前建立的，申報後系統未自動移除既有指派",
    "主辦方在明知已有利益衝突宣告的情況下，仍手動將該作品指派給該評審"
  ],
  "diagnosis": [
    {
      "title": "Step 1",
      "description": "前往「審查進度」頁，查看下方利益衝突清單，確認該筆組合的評審、隊伍與申報原因。"
    },
    {
      "title": "Step 2",
      "description": "查看該筆記錄的「來源」欄位，區分是評審自行申報，或是由主辦方人工登記；兩種來源都可能造成與既有指派重疊。"
    },
    {
      "title": "Step 3",
      "description": "確認是否已經知道要換給哪一位評審：知道的話可直接用「重新指派」一步處理；不確定的話可先用「僅取消指派」。"
    }
  ],
  "resolution": "若已決定替代評審，在利益衝突清單該列點選「重新指派」，從下拉選單選擇新評審並確認：系統會先對新評審重新驗證利益衝突，通過後立即建立新指派並移除原本重疊的舊指派，不需要再前往「作品指派」分頁。若尚未決定替代評審，可改點「僅取消指派」（需填寫原因），該筆重疊指派會轉為已取消，之後再自行前往「作品指派」分頁指派替代評審。若您本身沒有這兩項操作的權限，請聯絡具有評審治理權限的競賽管理員（competition_admin）協助處理。",
  "stillStuck": [
    "競賽名稱",
    "評審姓名／Email",
    "受影響的作品名稱或代碼",
    "利益衝突申報時間與來源",
    "Screenshot（審查進度頁的利益衝突清單）"
  ],
  "doNotProvide": ["密碼", "驗證碼", "Token"],
  "nextSteps": "確認後仍不確定如何處理，請見「讀懂審查進度與利益衝突警示」重新了解本頁各欄位的意義。"
}
